import { IApplicationState } from '@Site/rootReducer'

export const getLoading = (state: IApplicationState) => state.authentication.loading
